import React from 'react'
import '../../views/container/cms/content.scss'
import date from '../Content-Icons/PNGs/date-icon-publish.png'
const DateIcon = () => {
  return <img src={date} alt="" style={{ height: '22px' }} />
}

export default DateIcon
